import $fn from '@/utils/fn.ts';
import httpApi from '@/apis/httpApi'
import http from "@/utils/http.js"
import requests from "@/utils/https.js"
import httpUploader from "@/utils/httpUploader.js"

// 上传图片
interface UploadImgJson {
    file: string,
    is_base64: number
}

export const uploadImg = (json: UploadImgJson): any => http.httpPost({
    url: httpApi.commonity.uploadImg,
    json
})

// 批量获取游戏信息
interface GetGamesInfoJson {
    ids: string,
}
export const getGamesInfo = (json: GetGamesInfoJson) => http.httpPost({
    url: httpApi.commonity.getGamesInfo,
    json
})

// 版规-基础
export const ruleBase = (): any => http.httpGet({
    url: httpApi.commonity.ruleBase,
})

// 版规-详情
interface RuleDetailJson {
    module_id: number
    id?: number
}
export const ruleDetail = (json: RuleDetailJson): any => http.httpGet({
    url: httpApi.commonity.ruleDetail,
    json
})

// 获取一级评论
interface GetCommentJson {
  subject_id: string,
  type: string,
  next_page: string | number,
  order_type: string,
  c_version: string,
  owner_uid: number | string
  limit: number
}
export const getComment = (json: GetCommentJson) => http.httpGet({
  url: httpApi.commonity.getComment,
  json
})
